import "../DrugAssignmentBatchRelease/DrugAssignment.css";
import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Checkbox, Divider, Grid2 } from "@mui/material";
import { Home, InfoOutlined } from "@mui/icons-material";
import {
  fetchAllBatchReleaseService,
  updateBatchApprovalStatus,
} from "../../services/batchReleaseApprovalService";
import StyledGridComp from "../../components/StyledGridComp";
import Loader from "../../components/Loader";
import SearchedComponent from "../../components/SearchedComponent";
import { notifyError, notifySuccess } from "../../utilities/helper";
import BatchReleaseConfirmPage from "./BatchReleaseConfirmPage";

const BatchReleaseApproval = () => {
  const [load, setLoad] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [rowData, setRowData] = useState([]);
  const [rowsWithId, setRowsWithId] = useState([]);
  const [rowLength, setRowLength] = useState(0);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchedValue, setSearchedValue] = useState("");
  const [modifiedRows, setModifiedRows] = useState({});
  const [showConfirmData, setShowConfirmData] = useState(false);
  const [confirmationData, setConfirmationData] = useState(null);
  const navigate = useNavigate();

  const access_token = localStorage?.getItem("access_token");
  const role = localStorage.getItem("role");
  const userId = localStorage.getItem("roleId");

  useEffect(() => {
    if (page >= 0 && pageSize && access_token && userId) {
      fetchAllBatchData(page, pageSize, access_token, debouncedSearch, userId);
    }
  }, [pageSize, page, debouncedSearch, userId]);

  // useEffect(() => {
  //   if (rowData && rowData?.length > 0) {
  //     const tempData = rowData?.map((row) => ({
  //       ...row,
  //       id: row.batchId,
  //     }));
  //     setRowsWithId(tempData);
  //   }
  // }, [rowData]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(searchedValue);
    }, 500);
    return () => clearTimeout(timeout);
  }, [searchedValue]);

  const handleCheckboxChange = (id, field) => {
    setRowsWithId((prevRows) =>
      prevRows.map((row) => {
        if (row.id !== id) return row;

        const updatedRow = {
          ...row,
          isApproved: field === "approve" ? !row.isApproved : false,
          isRejected: field === "reject" ? !row.isRejected : false,
        };

        setModifiedRows((prev) => {
          const newModifiedRows = { ...prev };

          // If both are false, remove from modifiedRows
          if (!updatedRow.isApproved && !updatedRow.isRejected) {
            delete newModifiedRows[id];
          } else {
            newModifiedRows[id] = updatedRow;
          }

          return newModifiedRows;
        });

        return updatedRow;
      }),
    );
  };

  const columns = [
    {
      field: "drugName",
      headerName: "Drug Name",
      width: 150,
      renderHeader: () => <div className="grid-heading">{"Drug Name"}</div>,
      renderCell: (params) => {
        const name = params.row.drugName;

        return <span>{name}</span>;
      },
    },
    {
      field: "sequenceRange",
      headerName: "Sequence Range",
      width: 200,
      renderHeader: () => (
        <div className="grid-heading">{"Sequence Range"}</div>
      ),
      renderCell: (params) => {
        const sequenceRange = params.row.sequenceRange;

        return <span>{sequenceRange}</span>;
      },
    },
    {
      field: "depotName",
      headerName: "Depot Name",
      width: 200,
      renderHeader: () => <div className="grid-heading">{"Depot Name"}</div>,
      renderCell: (params) => {
        const depotName = params.row.depotName;

        return <span>{depotName}</span>;
      },
    },
    {
      field: "lotNumber",
      headerName: "Lot Number",
      width: 200,
      renderHeader: () => <div className="grid-heading">{"Lot Number"}</div>,
      renderCell: (params) => {
        const lotNumber = params.row.lotNumber;

        return <span>{lotNumber}</span>;
      },
    },
    {
      field: "labelGroupName",
      headerName: "Label Group Name",
      width: 180,
      renderHeader: () => (
        <div className="grid-heading">{"Label Group Name"}</div>
      ),
      renderCell: (params) => {
        const labelGroupName = params.row.labelGroupName;

        return <span>{labelGroupName}</span>;
      },
    },
    {
      field: "kitQuantity",
      headerName: "Kit Quantity",
      width: 200,
      renderHeader: () => <div className="grid-heading">{"Kit Quantity"}</div>,
      renderCell: (params) => {
        const kitQuantity = params.row.kitQuantity;

        return <span>{kitQuantity}</span>;
      },
    },
    {
      field: "protocol",
      headerName: "Protocol",
      width: 200,
      renderHeader: () => <div className="grid-heading">{"Protocol"}</div>,
      renderCell: (params) => {
        const protocol = params.row.protocol;

        return <span>{protocol}</span>;
      },
    },
    {
      field: "isSingleDrugBatchStatus",
      headerName: "Single Drug Batch",
      width: 200,
      renderHeader: () => (
        <div className="grid-heading">{"Single Drug Batch"}</div>
      ),
      renderCell: (params) => {
        const isSingleDrugBatchStatus = params.row.isSingleDrugBatchStatus;

        return <span>{isSingleDrugBatchStatus}</span>;
      },
    },
    {
      field: "performedBy",
      headerName: "Performed By",
      width: 200,
      renderHeader: () => <div className="grid-heading">{"Performed By"}</div>,
      renderCell: (params) => {
        const performedBy = params.row.performedBy;

        return <span>{performedBy}</span>;
      },
    },
    {
      field: "approve",
      headerName: "Approve",
      width: 200,
      renderHeader: () => <div className="grid-heading">Approve</div>,
      renderCell: (params) => (
        <Checkbox
          checked={!!params.row.isApproved}
          onChange={() => handleCheckboxChange(params.row.id, "approve")}
        />
      ),
    },
    {
      field: "reject",
      headerName: "Reject",
      width: 200,
      renderHeader: () => <div className="grid-heading">Reject</div>,
      renderCell: (params) => (
        <Checkbox
          checked={!!params.row.isRejected}
          onChange={() => handleCheckboxChange(params.row.id, "reject")}
        />
      ),
    },
  ];

  const fetchAllBatchData = async (
    page,
    pageSize,
    access_Token,
    debouncedSearch = "",
    userId,
  ) => {
    setLoad(true);
    try {
      const res = await fetchAllBatchReleaseService(
        page + 1,
        pageSize,
        access_Token,
        debouncedSearch,
        userId,
      );
      if (res?.status === 200) {
        setRowData(res?.data?.result);
        const tempData = res?.data?.result?.map((row) => ({
          ...row,
          id: row.batchId,
        }));
        setRowsWithId(tempData);
        setRowLength(res?.data?.result?.length);
        setLoad(false);
      } else if (res?.status == 401) {
        navigate("/unauthorize");
      }
    } catch (err) {
      setLoad(false);
      if (err?.status == 401) {
        navigate("/unauthorize");
      }
    }
  };

  const handleSearch = useCallback((e) => {
    setSearchedValue(e.target.value);
  }, []);

  const handleSave = async () => {
    const updatedData = Object.values(modifiedRows);
    const newData = {
      batchReleaseApprovalDrugs: updatedData,
    };
    setLoad(true);
    try {
      const res = await updateBatchApprovalStatus(
        access_token,
        newData,
        userId,
      );
      if (res?.status === 200) {
        setLoad(false);
        notifySuccess("Batch Release Approved Successfully");

        fetchAllBatchData(
          page,
          pageSize,
          access_token,
          debouncedSearch,
          userId,
        );
        setShowConfirmData(true);
        setConfirmationData(res?.data?.result);
      }
    } catch (err) {
      setLoad(false);
      console.log("Error in saving data:", err);
      setShowConfirmData(false);
      notifyError(err?.message);
      if (err?.status == 401) {
        navigate("/unauthorize");
      }
    }
  };

  return (
    <>
      {showConfirmData ? (
        <BatchReleaseConfirmPage
          setShowConfirm={setShowConfirmData}
          data={confirmationData}
        />
      ) : (
        <div className="content-body">
          <div className="home-container">
            <p
              className="bread-crumbs-link-container"
              style={{ fontWeight: "600" }}
            >
              <Link className="bread-crumbs-link" to="/">
                Home
              </Link>{" "}
              |{" "}
              <Link className="bread-crumbs-link" to="/batch-release-approval">
                Batch Release Approval
              </Link>{" "}
              -{" "}
              <b style={{ color: "gray" }}>
                {localStorage?.getItem("studyName")}
              </b>
            </p>
            <Link className="bread-crumbs-link home-inner-container">
              Set as Home Page
              <span>
                <Home
                  sx={{
                    fontSize: "20px",
                  }}
                />
              </span>
            </Link>
          </div>
          <Grid2
            container
            alignItems="center"
            justifyContent="space-between"
            sx={{ width: "100%", margin: "0 auto" }}
          >
            <Grid2 item md={6} sx={{ width: "100%" }}>
              <p className="page-heading">Batch Release Approval</p>
              <Divider />
              <div
                style={{ display: "flex", gap: "20px", alignItems: "center" }}
              >
                <p className="page-sub-header">
                  <InfoOutlined className="info-icon" />
                  Batch Releases that have been created via "Drug
                  Assignment-Batch Release" page, can be approved or Rejected
                  here. Users can only see Batch Release Requests created by
                  other Users. Upon Approving a Batch, the kits will be updated
                  to "Available at Depot" Status.{" "}
                </p>
              </div>
            </Grid2>
          </Grid2>

          <div
            className="search-bar-container"
            style={{
              display: "flex",
              justifyContent: "end",
              margin: "1% 0% 1% 0%",
            }}
          >
            <SearchedComponent
              handleSearch={handleSearch}
              placeholder="Batches"
              searchedValue={searchedValue}
            />
          </div>

          {load ? (
            <Loader />
          ) : (
            <StyledGridComp
              rows={rowsWithId}
              columns={columns}
              page={page}
              setPage={setPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              length={rowLength}
            ></StyledGridComp>
          )}

          <Grid2
            alignItems={"end"}
            justifyContent="end"
            container
            sx={{ marginTop: "2%", gap: "20px" }}
          >
            <Grid2 item md={6}>
              <button className="create-btn-outlined">Back</button>
            </Grid2>
            <Grid2 item md={6}>
              <button
                className={
                  Object.keys(modifiedRows).length === 0
                    ? "disabled-btn"
                    : "create-btn"
                }
                onClick={handleSave}
                disabled={Object.keys(modifiedRows).length === 0}
              >
                Save
              </button>
            </Grid2>
          </Grid2>
        </div>
      )}
    </>
  );
};

export default BatchReleaseApproval;
